
import React from 'react';
import { Clock } from 'lucide-react';
import { CompetenceData } from '../../data/competencesData';

interface CompetenceProcessProps {
  processus: CompetenceData['processus'];
}

const CompetenceProcess = ({ processus }: CompetenceProcessProps) => {
  return (
    <div className="mb-12">
      <h2 className="text-2xl font-semibold text-navy-900 mb-8 flex items-center gap-2">
        <Clock className="text-blue-600" size={24} />
        Processus d'intervention
      </h2>
      <div className="space-y-6">
        {processus.map((etape, index) => (
          <div key={index} className="flex gap-6 items-start">
            <div className="bg-gradient-to-r from-blue-600 to-navy-700 text-white w-8 h-8 rounded-full flex items-center justify-center font-semibold flex-shrink-0">
              {index + 1}
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-navy-900">{etape.etape}</h3>
                <span className="text-sm text-blue-600 bg-blue-50 px-3 py-1 rounded-full">{etape.duree}</span>
              </div>
              <p className="text-navy-600 leading-relaxed">{etape.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompetenceProcess;
